export const ENTITY_STATUS_ACTIVE = 'Active';
export const ENTITY_STATUS_TERMINATED = 'Terminated';
export const ENTITY_STATUS_NOTICES_PENDING = 'Notices Pending';
export const TERMINATION_LIFECYCLE_STATUS_BLOCKER = 'Blocker';
